@if (editMode) {
  <div>
    <div class="field title-selection">
      <label>{{ 'COMMUNICATIONS.DESIGNER.ELEMENT-TYPE-2' | translate }}</label>
      <div>
        <input
          (ngModelChange)="headerChanged($event)"
          class="input is-small is-fullwidth"
          type="text"
          placeholder="{{ 'COMMUNICATIONS.DESIGNER.ELEMENT-TYPE-2' | translate }}"
          [(ngModel)]="richText" />
      </div>
    </div>
    <div class="field title-selection">
      <label>{{ 'MANAGEMENT.DATASETS.COLOR' | translate }}</label>
      <topo-color-picker [selectedColor]="color"
        (selectedColorChanged)="colorChanged($event)"
      [selectedColorWidth]="54"></topo-color-picker>
    </div>
  </div>
}
@if (!editMode) {
  <div
  style="
      font-size: 18px;
      font-family: Verdana, Geneva, Tahoma, sans-serif;
      font-weight: 700;
      margin-top: 8px;
      display: block;"
    [ngStyle]="{ 'color': color }">
    {{ richText }}
  </div>
}